const API_URL = process.env.REACT_APP_BACKEND_URL;
const TICK_MS = 15000;
const FLUSH_MS = 30000;
const IDLE_MS = 60000;
const SESSION_IDLE_MS = 30 * 60 * 1000;

export const MODULES = [
  ['/dashboard', 'dashboard', 'Dashboard'],
  ['/submit', 'submit_task', 'Submit Task'],
  ['/tasks/brand', 'brand_workspace', 'Brand Workspace'],
  ['/tasks', 'task_log', 'Task Log'],
  ['/assignee', 'assignee_tracker', 'Assignee Tracker'],
  ['/asset-library', 'asset_library', 'Asset Library'],
  ['/listing-quality', 'pdp_checker', 'PDP Checker'],
  ['/sku-live-status', 'sku_live_status', 'SKU Live Status'],
  ['/sku-dna', 'sku_dna', 'SKU DNA'],
  ['/creative-analyzer', 'creative_analyzer', 'Creative Analyzer'],
  ['/creative-log', 'creative_log', 'Creative Log'],
  ['/competitor-radar', 'competitor_radar', 'Competitor Radar'],
  ['/competitor-repository', 'competitor_repository', 'Competitor Repository'],
  ['/ean-request', 'ean_request', 'EAN Request'],
  ['/new-product-launch', 'new_product_launch', 'New Product Launch'],
  ['/settings', 'settings', 'Settings'],
];

const LABELS = Object.fromEntries(MODULES.map(([, k, l]) => [k, l]));
export const moduleLabel = (key) => LABELS[key] || key;
const moduleFor = (path) => (MODULES.find(([p]) => path.startsWith(p)) || [null, 'other'])[1];

const sessionId = () => {
  const now = Date.now();
  let id = sessionStorage.getItem('prism_usage_sid');
  const last = Number(sessionStorage.getItem('prism_usage_last') || 0);
  if (!id || now - last > SESSION_IDLE_MS) {
    id = `${now.toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('prism_usage_sid', id);
  }
  sessionStorage.setItem('prism_usage_last', String(now));
  return id;
};

const state = { queue: [], module: null, path: '', lastTick: 0, lastInput: Date.now(), started: false };

const isActive = () => document.visibilityState === 'visible' && Date.now() - state.lastInput < IDLE_MS;

const accrue = () => {
  const now = Date.now();
  if (state.module && state.lastTick && isActive()) {
    const ms = now - state.lastTick;
    if (ms > 0) state.queue.push({ type: 'time', module: state.module, path: state.path, duration_ms: ms });
  }
  state.lastTick = now;
};

const flush = () => {
  accrue();
  if (!state.queue.length) return;
  const events = state.queue.splice(0, 100);
  fetch(`${API_URL}/api/usage/track`, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId(), events }),
  }).catch(() => {});
};

const markInput = () => { state.lastInput = Date.now(); };

const start = () => {
  if (state.started) return;
  state.started = true;
  ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'].forEach((e) =>
    window.addEventListener(e, markInput, { passive: true }));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
    else { markInput(); state.lastTick = Date.now(); }
  });
  window.addEventListener('pagehide', flush);
  setInterval(accrue, TICK_MS);
  setInterval(flush, FLUSH_MS);
};

export const trackPageView = (path) => {
  start();
  accrue();
  state.module = moduleFor(path);
  state.path = path;
  state.lastTick = Date.now();
  markInput();
  state.queue.push({ type: 'page_view', module: state.module, path });
};
